interface Config {
  apiUrl: string;
  googleMapsApiKey: string;
  googleOAuthRedirectUrl: string;
  helpUrl: string;
  markerIoProjectId: string;
  env: string;
  trackingEnabled: boolean;
  debug: boolean;
}

declare global {
  interface Window {
    __config: Config | null;
  }
}

// Environment configuration
const envConfig: Config = {
  apiUrl: (import.meta.env.VITE_API_URL as string | undefined) ?? window.location.origin,
  googleMapsApiKey: (import.meta.env.VITE_GOOGLE_MAP_API_KEY as string | undefined) ?? '',
  googleOAuthRedirectUrl: (import.meta.env.VITE_GOOGLE_OAUTH_REDIRECT_URL as string | undefined) ?? window.location.origin,
  debug: import.meta.env.VITE_DEBUG === 'true',
  env: import.meta.env.VITE_ENV ?? 'development',
  helpUrl: (import.meta.env.VITE_HELP_URL as string | undefined) ?? '',
  markerIoProjectId: (import.meta.env.VITE_MARKER_IO_PROJECT_ID as string | undefined) ?? '',
  trackingEnabled: import.meta.env.VITE_TRACKING_ENABLED === 'true',
} as const;

const config = {
  ...envConfig,
  ...(window.__config ?? {}),
};

// Validate required environment variables
function validateEnvironment() {
  const errors: string[] = [];

  if (!config.apiUrl) {
    errors.push('VITE_API_URL is required');
  }

  if (config.env === 'development') {
    errors.push('VITE_ENV is set to development');
  }

  if (errors.length > 0) {
    throw new Error(`Missing required environment variables: ${errors.join(', ')}`);
  }
}

// Call validation on import
if (import.meta.env.MODE === 'production') {
  validateEnvironment();
}

export { config };
